var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"step"},[_c('div',{staticClass:"dot"},[_vm._v("\n    "+_vm._s(_vm.number)+"\n  ")]),_vm._v(" "),_c('div',{staticClass:"step-title"},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('div',{staticClass:"content"},[_vm._v(_vm._s(_vm.text))])])
}
var staticRenderFns = []

export { render, staticRenderFns }